<template>
    <svg
        :width="size"
        :height="size"
        overflow="visible"
    >
        <path
            class="bubble"
            :d="bubblePath"
        />

        <!-- x and y positions chosen by trial and error -->
        <text
            class="label"
            :x="size * 0.55"
            :y="size * 0.55"
            dy="0.3em"
        >
            <tspan class="label-value">{{ value }}</tspan>
            <tspan
                class="label-units"
            >{{ valueUnits }}</tspan>
        </text>
    </svg>
</template>

<script>
export default {
    props: {
        size: {
            type: Number,
            default: 50
        },
        value: {
            type: String,
            required: true
        },
        valueUnits: {
            type: String,
            default: '%'
        }
    },
    computed: {
        bubblePath() {
            return `
                M ${this.size} ${this.size}
                L ${this.size / 2} ${this.size}
                A ${this.size / 2} ${this.size / 2} 0 1 1 ${this.size} ${this.size / 2}
                L ${this.size} ${this.size}
                L ${this.size / 2} ${this.size}`; // Repeat the last line segment so there's no gap in the corner
        }
    }
};
</script>

<style lang="postcss" scoped>
text.label {
    text-anchor: middle;
    @apply fill-current text-3xl font-bold;
}

tspan.label-units {
    @apply text-2xl;
}

path.bubble {
    @apply stroke-current;
    fill: none;
    stroke-width: 6px;
}
svg {
    overflow: visible !important;
}
</style>
